import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";

export default function LogoAndBranding() {
  return (
    <div className="Logo-And-Branding pt-[160px] sm:pt-0">
      <Helmet>
        <title>Transform Your Brand with Expert Logo & Branding Design</title>
        <meta
        name="description"
        content="Stand out with a logo that tells your brand’s story! Mean3 offers creative, custom logo and branding services in Dubai to help your business make a lasting impression."
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
    </div>
  );
}
